import { EventContent, Events } from "./enum";
const nullIfEmpty = (arr) => arr.length === 0 ? undefined : arr;
const emitHandlerMap = {
    delete_view: (data) => {
        return data.viewUid;
    },
    request_event: (data) => {
        return {
            [EventContent.EventUid]: data.eventUid,
            [EventContent.EventArgs]: data.eventArguments,
            [EventContent.Uid]: data.uid,
        };
    },
    request_views_tree: () => {
        return undefined;
    },
    respond_to_event: (data) => {
        return {
            [EventContent.Data]: data.data,
            [EventContent.EventUid]: data.eventUid,
            [EventContent.Uid]: data.uid,
        };
    },
    update_view: (data) => {
        return {
            [EventContent.ChildIndex]: data.view.childIndex,
            [EventContent.Name]: data.view.name,
            [EventContent.ParentUid]: data.view.parentUid,
            [EventContent.Props]: {
                [EventContent.Create]: nullIfEmpty(data.view.props.create)?.map((prop) => ({
                    [EventContent.Data]: prop.type === "data" ? prop.data : undefined,
                    [EventContent.Name]: prop.name,
                    [EventContent.Type]: prop.type === "data" ? EventContent.Data : EventContent.Event,
                    [EventContent.Uid]: prop.type === "event" ? prop.uid : undefined,
                })),
                [EventContent.Merge]: nullIfEmpty(data.view.props.merge)?.map((prop) => ({
                    [EventContent.Data]: prop.type === "data" ? prop.data : undefined,
                    [EventContent.Name]: prop.name,
                    [EventContent.Type]: prop.type === "data" ? EventContent.Data : EventContent.Event,
                    [EventContent.Uid]: prop.type === "event" ? prop.uid : undefined,
                })),
                [EventContent.Delete]: nullIfEmpty(data.view.props.delete),
            },
            [EventContent.Uid]: data.view.uid,
            [EventContent.isRoot]: data.view.isRoot,
        };
    },
    update_views_tree: (data) => {
        return {
            [EventContent.Views]: data.views.map((view) => ({
                [EventContent.ChildIndex]: view.childIndex,
                [EventContent.Name]: view.name,
                [EventContent.ParentUid]: view.parentUid,
                [EventContent.Props]: view.props.map((prop) => ({
                    [EventContent.Data]: prop.type === "data" ? prop.data : undefined,
                    [EventContent.Name]: prop.name,
                    [EventContent.Type]: prop.type === "data" ? EventContent.Data : EventContent.Event,
                    [EventContent.Uid]: prop.type === "event" ? prop.uid : undefined,
                })),
                [EventContent.Uid]: view.uid,
                [EventContent.isRoot]: view.isRoot,
            })),
        };
    },
};
const map = {
    delete_view: Events.DeleteView,
    request_event: Events.RequestEvent,
    request_views_tree: Events.RequestViewsTree,
    respond_to_event: Events.RespondToEvent,
    update_view: Events.UpdateView,
    update_views_tree: Events.UpdateViewsTree,
};
const onHandlerMap = {
    [Events.DeleteView]: (data) => {
        return { viewUid: data };
    },
    [Events.RequestEvent]: (data) => {
        return {
            eventArguments: data[EventContent.EventArgs] || [],
            eventUid: data[EventContent.EventUid],
            uid: data[EventContent.Uid],
        };
    },
    [Events.RequestViewsTree]: () => {
        return;
    },
    [Events.RespondToEvent]: (data) => {
        return {
            data: data[EventContent.Data],
            eventUid: data[EventContent.EventUid],
            uid: data[EventContent.Uid],
        };
    },
    [Events.UpdateView]: (data) => {
        return {
            view: {
                childIndex: data[EventContent.ChildIndex],
                name: data[EventContent.Name],
                parentUid: data[EventContent.ParentUid],
                props: {
                    create: (data[EventContent.Props][EventContent.Create] || []).map((prop) => ({
                        name: prop[EventContent.Name],
                        data: prop[EventContent.Data],
                        type: prop[EventContent.Type] === EventContent.Data ? "data" : "event",
                        uid: prop[EventContent.Uid],
                    })),
                    merge: (data[EventContent.Props][EventContent.Merge] || []).map((prop) => ({
                        name: prop[EventContent.Name],
                        data: prop[EventContent.Data],
                        type: prop[EventContent.Type] === EventContent.Data ? "data" : "event",
                        uid: prop[EventContent.Uid],
                    })),
                    delete: data[EventContent.Props][EventContent.Delete] || [],
                },
                uid: data[EventContent.Uid],
                isRoot: data[EventContent.isRoot],
            },
        };
    },
    [Events.UpdateViewsTree]: (data) => {
        return {
            views: (data[EventContent.Views] || []).map((view) => ({
                childIndex: view[EventContent.ChildIndex],
                name: view[EventContent.Name],
                parentUid: view[EventContent.ParentUid],
                props: (view[EventContent.Props] || []).map((prop) => ({
                    name: prop[EventContent.Name],
                    data: prop[EventContent.Data],
                    type: prop[EventContent.Type] === EventContent.Data ? "data" : "event",
                    uid: prop[EventContent.Uid],
                })),
                uid: view[EventContent.Uid],
                isRoot: view[EventContent.isRoot],
            })),
        };
    },
};
export const decompileTransport = (transport) => {
    const on = (event, handler) => {
        const handlerExtended = (data) => {
            handler(onHandlerMap[map[event]](data));
        };
        transport.on(String(map[event]), handlerExtended);
        return () => transport.off?.(String(map[event]), handlerExtended);
    };
    const emit = (event, data) => {
        transport.emit(String(map[event]), emitHandlerMap[event](data));
    };
    return { on, emit };
};
const emitFactory = () => {
    const events = map;
    return new Proxy(events, {
        get: (target, prop) => {
            if (prop in target) {
                return (transport, data) => {
                    transport.emit(String(map[prop]), emitHandlerMap[prop](data));
                };
            }
            return undefined;
        }
    });
};
/**
 * for usage in custom clients
 */
export const emit = emitFactory();
//# sourceMappingURL=decompiled-transport.js.map